// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // @ts-ignore
  production: ('true' === 'true'),
  // @ts-ignore
  // logger: ('{{LOGGER}}' === 'true'),
  apiEndpoint: 'https://api.beopen.com',
  openPortal: 'https://portal.beopen.com',
  huddleFrontal: 'https://huddle.com.au',
  datadogClientToken: 'pub47cb921cb446450029180cfc8b5e1f7f',
  datadogApplicationId: '3c82d8a1-f44b-492a-8189-919bc37757d3',
  datadogService: 'open-portal',
  datadogSite: 'datadoghq.com',
  env: 'production',
  smartFlightDelay: 'http://huddle.smartdelay.com',
  version: "v11/v11.17/v11.17.0",
  region: "australia",
  cioDataSiteId: "07621fe87147ed731496"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
